import { inject } from "@vercel/analytics";

const injectVercelAnalytics = () => {
  inject();
};

export default injectVercelAnalytics;
